import React from 'react';
import { ListOptionType } from '@reducers/listReducer';
import { DispatchProp, connect } from 'react-redux';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';
import { compose } from 'react-apollo';
import { ApplicationState } from 'reducers/';
import ReactTable, { Column, SortingRule, RowInfo, Filter } from 'react-table';
import { updateListOptions } from '@actions/listActions';
import { OrderDirection } from '@api/graphql/types';

interface ReduxProps {
    listOptions: ListOptionType;
}

interface PropType {
    columns: Array<Column<any>>;
    listName: string;
    defaultOptions: ListOptionType;
    data: any[];
    onClick?: (rowInfo: RowInfo) => void;
    defaultSorted?: any;
    defaultPageSize?: number;
    multiSort?: boolean;
    sortable?: boolean;
    filterable?: boolean;
    getTdProps?: (finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any) => object;
}

type Props = PropType & ReduxProps & DispatchProp & InjectedIntlProps & RouteComponentProps;

class ReduxTable extends React.Component<Props> {
    private onFilteredChange = (newFiltering: Filter[], column: any, value: any) => {
        const filters = newFiltering.reduce((map, obj) => {
            map[obj.id] = obj.value;
            return map;
        }, {});

        const options = {
            ...this.props.listOptions,
            filters,
        };

        this.props.dispatch(updateListOptions(this.props.listName, options));
    }

    private getFiltered = () => {
        return this.props.listOptions.filters ?
            Object.entries(this.props.listOptions.filters).map(([id, value]) => ({id, value})) :
            [];
    }

    private onSortedChange = (newSorted: SortingRule[], column: any, additive: boolean) => {
        const rule = newSorted[newSorted.length - 1];
        const options = {
            ...this.props.listOptions,
            sortBy: {
                field: rule.id,
                direction: rule.desc ? OrderDirection.DESC : OrderDirection.ASC,
            },
        };
        this.props.dispatch(updateListOptions(this.props.listName, options));
    }

    private getSorted = (): SortingRule[] => {
        return [{
            id: this.props.listOptions.sortBy.field,
            desc: this.props.listOptions.sortBy.direction ===  OrderDirection.DESC ? true : undefined,
            asc: this.props.listOptions.sortBy.direction ===  OrderDirection.ASC ? true : undefined,
        }];
    }

    private onPageSizeChanged = (newPageSize: number, newPage: number) => {
        const options = {
            ...this.props.listOptions,
            page: newPage,
            count: newPageSize,
        };
        this.props.dispatch(updateListOptions(this.props.listName, options));
    }

    private onPageChange = (page: number) => {
        const options = {
            ...this.props.listOptions,
            page,
        };
        this.props.dispatch(updateListOptions(this.props.listName, options));
    }

    private onRowClick(finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any) {
        if (this.props.getTdProps) {
            return this.props.getTdProps(finalState, rowInfo, column, instance);
        }

        if (rowInfo && this.props.onClick) {
            return {
                onClick: () => {
                    this.props.onClick!(rowInfo);
                },
                style: {
                    cursor: 'pointer',
                },
            };
        }
        return {};
    }

    public render() {
        return (
            <ReactTable
                data={this.props.data}
                columns={this.props.columns}
                defaultPageSize={this.props.defaultPageSize}
                defaultSorted={this.props.defaultSorted}
                className="-striped -highlight"
                getTdProps={(finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any) => this.onRowClick(finalState, rowInfo, column, instance)}
                filterable={this.props.filterable}
                minRows={1}

                multiSort={this.props.multiSort}

                sortable={this.props.sortable}

                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChanged}
                onSortedChange={this.onSortedChange}
                onFilteredChange={this.onFilteredChange}
                page={this.props.listOptions.page}
                pageSize={this.props.listOptions.count}
                sorted={this.getSorted()}
                filtered={this.getFiltered()}
            />
        );
    }
}

const mapStateToProps = ({ lists }: ApplicationState, props: PropType): ReduxProps => {
    return { listOptions: (lists ? (lists[props.listName] || props.defaultOptions) : props.defaultOptions) };
};

export default compose(
    withRouter,
    injectIntl,
    connect(mapStateToProps),
)(ReduxTable);



// WEBPACK FOOTER //
// ./src/components/ReduxTable.tsx